import React from 'react'

import NavBar from '../NewLanding/components/newNavbar';
import Footer from '../NewLanding/components/newFooter';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import DivisionTitle from '../NewLanding/components/divisionTitle';

export default function Terms() {
  return (<>
    <NavBar />

    <Container fluid className='py-5em mt-5em'>
        <Container className='custom-container'>
          <Row>
            <Col lg='12' className='text-center'>
              <DivisionTitle
                title="Terms and Conditions"
              />
            </Col>
          </Row>
        </Container>
      </Container>

    <Container fluid className="bg-blue-shade py-5">
      <Container>
        <Row>
          <Col md={{ size: '10', offset: '1' }} lg={{ size: '8', offset: '2' }} style={{ fontSize: '1.05rem', lineHeight: '1.5' }}>
            <h3>Agreement between User and <a href="https://www.sparkapt.com" rel="noreferrer" target="_blank">www.sparkapt.com</a></h3>
            <p>Welcome to <a href="https://www.sparkapt.com" rel="noreferrer" target="_blank">www.sparkapt.com</a> (the "Site"). The Site is operated by RentalSearcher LLC, a Delaware limited liability company doing business as SparkAPT ("SparkAPT," "we," "us," or "our"). Your access to and use of the Site and related services (collectively, the "Services") is subject to the following terms, conditions, and notices (the "Terms"). By accessing or using the Services, you agree to be bound by these Terms. Please review them carefully and retain a copy for your records.</p>

            <h3>Service Description</h3>
            <p>SparkAPT provides software as a service for licensed real estate agents, multifamily apartment communities, and property owners to access, organize, and analyze pricing, availability, commissions, and related real estate data.</p>

            <h3>Client Information and Data Privacy</h3>
            <p><u>Data Ownership</u>: You retain all rights to data you input into the Services. SparkAPT does not claim ownership of your data.</p>
            <p><u>Data Use</u>: We access and use your data solely as necessary to provide and support the Services.</p>
            <p><u>Data Security</u>: We implement commercially reasonable security measures; however, no system is completely secure. Use of the Services is at your own risk with respect to data security.</p>
            <p><u>Limitation of Liability for Data</u>: To the fullest extent permitted by law, SparkAPT disclaims liability for unauthorized access, loss, or alteration of your data.</p>
            <p><u>Indemnification</u>: You agree to indemnify and hold SparkAPT harmless from claims arising from your data or your use of the Services.</p>

            <h3>Privacy</h3>
            <p>Your use of the Services is subject to our Privacy Policy.</p>

            <h3>Electronic Communications</h3>
            <p>You consent to receive communications electronically and agree such communications satisfy legal requirements for written notice.</p>

            <h3>Text Messages and Notifications</h3>
            <p>By creating an account, you consent to receive automated notifications. You may opt out at any time through your account settings. Standard carrier charges may apply.</p>

            <h3>Your Account</h3>
            <p>You are responsible for maintaining the confidentiality of your account and all activity under it. SparkAPT may suspend or terminate accounts at its discretion.</p>

            <h3>Children</h3>
            <p>The Services are not intended for users under 13. Users under 18 must have parental consent.</p>

            <h3>Fees and Cancellation</h3>
            <p>All fees are non-refundable except as required by law. You may cancel your subscription through your account settings.</p>

            <h3>Third-Party Services</h3>
            <p>The Services may include links to third-party services. SparkAPT is not responsible for third-party content or services.</p>

            <h3>No Unlawful or Prohibited Use; Intellectual Property</h3>
            <p>You are granted a limited, non-exclusive, non-transferable, revocable license to access and use the Services in accordance with these Terms.</p>
            <p>You agree that you will not:</p>
            <p><u>Competitive Use</u>: Access or use the Services to develop, support, or enable a competing product or service, or if you are a competitor or acting on behalf of one.</p>
            <p><u>Data Extraction and Scraping</u>: Use any automated or systematic means, including bots, scrapers, crawlers, or similar technologies, to access or extract data from the Services. You may not bypass or circumvent any security measures, rate limits, or access controls.</p>
            <p><u>API and GraphQL Misuse</u>: Use any SparkAPT API, including GraphQL endpoints, in a manner that exceeds authorized usage, replicates the Services, or enables unauthorized third-party access. You may not cache, store, or aggregate API responses beyond what is necessary for permitted use.</p>
            <p><u>AI and Model Training Restrictions</u>: Use any data from the Services to train, fine-tune, evaluate, or develop machine learning or artificial intelligence systems without prior written consent.</p>
            <p><u>Reverse Engineering and Dataset Reconstruction</u>: Attempt to reconstruct or replicate the Services or underlying datasets through systematic querying, aggregation, benchmarking, or analysis.</p>
            <p><u>Benchmarking and Competitive Analytics</u>: Use the Services or data to create benchmarking tools, market intelligence, pricing models, or analytics products that compete with SparkAPT.</p>
            <p><u>Resale and Commercial Exploitation</u>: Sell, license, distribute, or otherwise exploit any data obtained from the Services.</p>
            <p><u>Customer Circumvention</u>: Contact any user or customer of the Services using data obtained from the Services without prior written consent.</p>

            <h3>API Access, Monitoring, and Enforcement</h3>
            <p>SparkAPT may monitor usage of the Services, including API activity, to ensure compliance with these Terms. We reserve the right to:</p>
            <ul>
              <li>enforce rate limits and usage thresholds</li>
              <li>suspend or terminate access for suspected violations</li>
              <li>investigate potential misuse</li>
              <li>audit usage patterns where reasonably necessary to enforce these Terms</li>
            </ul>

            <h3>Intellectual Property</h3>
            <p>All content, data, software, and materials in the Services are owned by SparkAPT or its licensors and are protected by applicable laws. No rights are granted except as expressly stated.</p>

            <h3>Remedies</h3>
            <p>You acknowledge that violations of this section may cause harm that is difficult to quantify. SparkAPT may seek injunctive relief and recover reasonable attorneys' fees.</p>
            <p>To the fullest extent permitted by law, damages are agreed to be $10,000 per violation as a reasonable estimate of harm and not a penalty.</p>

            <h3>Indemnification</h3>
            <p>You agree to indemnify and hold harmless SparkAPT from any claims arising from your use of the Services or violation of these Terms.</p>

            <h3>Arbitration</h3>
            <p>All disputes shall be resolved by binding arbitration under the Federal Arbitration Act, administered by the American Arbitration Association, in the State of Delaware, unless otherwise agreed. The arbitrator's decision shall be final and enforceable.</p>

            <h3>Liability Disclaimer</h3>
            <p>THE SERVICES MAY CONTAIN INACCURACIES OR ERRORS. SPARKAPT MAY MODIFY THE SERVICES AT ANY TIME.</p>
            <p>TO THE FULLEST EXTENT PERMITTED BY LAW, THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND. SPARKAPT DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED.</p>
            <p>SPARKAPT IS NOT RESPONSIBLE FOR THE ACCURACY, COMPLETENESS, OR RELIABILITY OF ANY THIRD-PARTY OR AGGREGATED DATA PRESENTED THROUGH THE SERVICES.</p>
            <p>TO THE FULLEST EXTENT PERMITTED BY LAW, SPARKAPT SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOSS OF DATA, REVENUE, OR PROFITS.</p>
            <p>WHERE LIMITATIONS ARE NOT PERMITTED, LIABILITY SHALL BE LIMITED TO THE MAXIMUM EXTENT ALLOWED BY LAW.</p>
            <p>YOUR SOLE REMEDY IS TO DISCONTINUE USE OF THE SERVICES.</p>

            <h3>Termination</h3>
            <p>SparkAPT may terminate or suspend access at any time without notice.</p>

            <h3>Governing Law</h3>
            <p>These Terms are governed by the laws of the State of Delaware.</p>

            <h3>Entire Agreement</h3>
            <p>These Terms constitute the entire agreement between you and SparkAPT.</p>

            <h3>Changes to Terms</h3>
            <p>SparkAPT may update these Terms at any time. Continued use constitutes acceptance.</p>

            <h3>Contact Us</h3>
            <p>
              RentalSearcher LLC<br/>
              11007 N Orange St. 4th Floor Suite #4328<br/>
              Wilmington, Delaware 19801
            </p>

            <p>
              Email:<br/>
              <a href="mailto:data@sparkapt.com">data@sparkapt.com</a>
            </p>

            <p>
              Phone:<br/>
              <a href="tel:737-900-6175">737-900-6175</a>
            </p>

            <p><strong>Effective 2026</strong></p>

          </Col>
        </Row>
      </Container>
    </Container>

    <Footer />
  </>)
}
